import { useAuth0 } from '@auth0/auth0-react'
import { locations } from '@cimpress-technology/logistics-configuration-client'
import * as React from 'react'
import * as uuid from 'uuid'
import { useLogisticsLocation } from '../../locations/LocationContext'

export function isActive(notification: locations.models.Notification) {
  return (
    notification.locationState === 'active' &&
    notification.userState === 'active'
  )
}

export function useNotifications() {
  const { getAccessTokenSilently } = useAuth0()
  const { logisticsLocation } = useLogisticsLocation()
  const [notifications, setNotifications] = React.useState<
    locations.models.Notification[]
  >([])
  const [loading, setLoading] = React.useState(true)

  const unreads = notifications.filter(isActive)

  const dismissUnreads = async () => {
    if (unreads.length > 0) {
      const token = await getAccessTokenSilently()
      await Promise.all(
        unreads.map(u =>
          locations.dismissNotification(token, uuid.v4(), u.locationId, u.id)
        )
      )

      return getAllNotifications()
    }
  }

  const createNotification = async (
    notification: Omit<locations.models.CreateNotification, 'locationId'>
  ) => {
    const token = await getAccessTokenSilently()
    await locations.createNotification(token, uuid.v4(), {
      ...notification,
      locationId: logisticsLocation.id,
    })

    return getAllNotifications()
  }

  const getAllNotifications = React.useCallback(async () => {
    const response = await locations.getAllNotifications(
      await getAccessTokenSilently(),
      uuid.v4(),
      logisticsLocation.id
    )
    setNotifications(response.items)
    setLoading(false)
  }, [getAccessTokenSilently, logisticsLocation.id])

  React.useEffect(() => {
    getAllNotifications()
  }, [getAllNotifications, logisticsLocation.id])

  return {
    loading,
    notifications,
    unreads,
    dismissUnreads,
    createNotification,
  }
}
